import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { hasTeamWorkspaceHomeAccess } from "services/utils/teamWorkspaceAccess";
import { isProvisioningLoaded } from "services/utils/HelperFunction";

export const HomeAccessGate = ({ children }) => {
  const userScreenAccess = useSelector(
    (state) => state.tokenReducer.userScreenAccess,
  );
  const moduleDetails = userScreenAccess?.module_details;

  // Wait for permissions before choosing the landing screen.
  // Redux holds one product's permissions at a time. Right after switching
  // into Team Workspace from another module it still holds that module's
  // (no "Home"/"Rosters" entry) until the sidebar's provisioning request
  // resolves, so judging them here bounced users to Attendance instead of
  // the Home screen they clicked (2026-10-01). Wait for Team Workspace's own.
  if (
    !isProvisioningLoaded(userScreenAccess, "Team Workspace") ||
    !Array.isArray(moduleDetails)
  ) {
    return null;
  }

  if (!hasTeamWorkspaceHomeAccess(moduleDetails)) {
    return <Redirect to="/admin/teamzone/attendance" />;
  }

  return children;
};
